import React, { useContext } from "react";
import { StackAnalysisContext } from "context/stack_analysis";
import StackFieldsSelection from "../StackFieldsSelection";
import StackSeasonsSelection from "../StackSeasonsSelection";
import StackCapturesSelection from "../StackCapturesSelection";
import ReviewSummary from "../ReviewSummary";

const StackAnalysisPage = () => {
  const { state } = useContext(StackAnalysisContext);
  const { currentPage } = state;

  return (
    <>
      {currentPage === "fields" && <StackFieldsSelection />}
      {currentPage === "seasons" && <StackSeasonsSelection />}
      {currentPage === "captures" && <StackCapturesSelection />}
      {currentPage === "review" && <ReviewSummary />}
    </>
  );
};

export default StackAnalysisPage;
